import { AxiomReportType } from '@/enums/axiom-report.enum'
import { IRvAttributionBySectorDTO } from '@/interfaces/rvReport.interface'
import { defaultColDefs } from '@/utils/grid-utils/colDefs'
import { getUpdatedColumnsWithTooltip } from '@/utils/tableGridUtils'
import {
  GridReadyEvent,
  ModuleRegistry,
  RowClassParams,
} from '@ag-grid-community/core'
import { CsvExportModule } from '@ag-grid-community/csv-export'
import { AgGridReact } from '@ag-grid-community/react'
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export'
import { sideBarDefaultConfig } from '@utils/grid-utils/ag-grid-config'
import React, { useRef } from 'react'
import { RvAttributionBySectorColumns } from './AttributionBySectorColumns'
export type IRVSummary = {
  rowData: IRvAttributionBySectorDTO[]
  setGridReference: Function
}

ModuleRegistry.registerModules([CsvExportModule, ExcelExportModule])
export const AttributionBySectorTable: React.FC<IRVSummary> = ({
  rowData,
  setGridReference,
}) => {
  const themeClassName = 'ag-theme-quartz'
  const gridRef = useRef<AgGridReact>(null)

  const onGridReady = (params: GridReadyEvent) => {
    if (document.body.clientWidth > 1400) {
      params.api.sizeColumnsToFit()
    } else {
      params.api.autoSizeAllColumns()
    }
    setGridReference(gridRef)
  }

  const getRowClass = (params: RowClassParams) => {
    if (params.node.level === -1) {
      return 'grand-total-row'
    }
    return ''
  }

  return (
    <div
      className={`${themeClassName}`}
      style={{
        boxSizing: 'border-box',
      }}
    >
      <AgGridReact
        ref={gridRef}
        onGridReady={onGridReady}
        defaultColDef={defaultColDefs}
        suppressAggFuncInHeader={true}
        columnDefs={getUpdatedColumnsWithTooltip(
          RvAttributionBySectorColumns,
          AxiomReportType.RV,
        )}
        rowData={rowData}
        grandTotalRow={'bottom'}
        getRowClass={getRowClass}
        sideBar={sideBarDefaultConfig}
        data-cy='attribution-by-sector-table'
      ></AgGridReact>
    </div>
  )
}
